import React, {FormEvent} from 'react'

import {FormField} from '../../../layout/Form'
import {Mod} from '../../../../types'

export type InputType = {
	label: string
	mod?: Mod<'half' | 'maxwidth' | 'error'>
	name: string
	placeholder: string
	required: boolean
	type: 'text' | 'number' | 'email' | 'date' | 'textarea' | 'tel' | 'url'
	value?: string
	min?: number
	max?: number
	disabled?: boolean
	onChange?: (value: string) => void
	confirmed?: boolean
	pattern?: string
	maxLength?: number
	minLength?: number
}

export const Input: React.FC<InputType> = ({
	label,
	mod,
	name,
	placeholder,
	required,
	type,
	value,
	min,
	max,
	disabled,
	onChange: onChangeHandler,
	pattern,
	maxLength,
	minLength
}) => {
	return (
		<FormField
			component={type === 'textarea' ? 'textarea' : null}
			label={label + (required ? ' (*)' : '')}
			mod={mod}
			name={name}
			placeholder={placeholder}
			required={required}
			type={type}
			value={value}
			min={min}
			max={max}
			disabled={disabled}
			onChange={(
				event: FormEvent<HTMLSelectElement> & {target: {value: string}}
			) => {
				if (onChangeHandler) {
					onChangeHandler(event.target.value as string)
				}
			}}
			pattern={pattern}
			maxLength={maxLength}
			minLength={minLength}
		/>
	)
}
